import { useCallback } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useEnquiry } from "./EnquiryModal";
import { useLanguage } from "../i18n/LanguageContext";

export const ProductCard = ({ product, index = 0 }) => {
  const { open } = useEnquiry();
  const { t } = useLanguage();
  const name = t(`products.${product.key}.name`);
  const desc = t(`products.${product.key}.desc`);

  const onMove = useCallback((e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
  }, []);

  return (
    <article
      data-testid={`product-card-${product.id}`}
      onMouseMove={onMove}
      className="spotlight-card group relative flex flex-col overflow-hidden rounded-lg border border-amber-500/20 bg-[#0F1E18]/75 backdrop-blur-sm transition-all duration-500 hover:border-amber-500/50 hover:shadow-[0_0_40px_rgba(212,175,55,0.12)]"
    >
      <Link
        to={`/products/${product.id}`}
        data-testid={`product-card-${product.id}-link`}
        className="relative block h-52 overflow-hidden sm:h-56"
      >
        <img
          src={product.img}
          alt={name}
          loading={index > 2 ? "lazy" : "eager"}
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F1E18] via-transparent to-transparent" />
        <span className="absolute left-4 top-4 font-serif text-4xl italic text-amber-400/50">
          {product.tag}
        </span>
      </Link>
      <div className="relative z-[3] flex flex-1 flex-col p-6">
        <Link to={`/products/${product.id}`}>
          <h3 className="font-serif text-2xl font-semibold text-emerald-50 transition-colors hover:text-amber-400">
            {name}
          </h3>
        </Link>
        <p className="mt-3 flex-1 text-sm font-light leading-relaxed text-slate-300/85">{desc}</p>
        <div className="mt-6 flex items-center gap-6">
          <button
            data-testid={`product-card-${product.id}-enquire-btn`}
            onClick={() => open({ product: product.nameEn, type: "Product Enquiry" })}
            className="inline-flex items-center gap-2 font-display text-xs font-semibold uppercase tracking-[0.2em] text-amber-400 transition-colors hover:text-amber-300"
          >
            {t("card.enquire")}
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
          <Link
            to={`/products/${product.id}`}
            data-testid={`product-card-${product.id}-details-link`}
            className="font-display text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 transition-colors hover:text-emerald-50"
          >
            {t("card.details")}
          </Link>
        </div>
      </div>
    </article>
  );
};
